import React from "react"
import { Button } from "react-bootstrap"
import { FaShoppingCart } from "react-icons/fa"
import { useStore } from "./StoreContext"
import { v4 as uuidv4 } from "uuid"

const AddToCartButton = ({ productData, successMsg }) => {
  const { dispatch } = useStore()

  const addItem = () => {
    dispatch({ type: "addItem", payload: { id: uuidv4(), ...productData } })
    successMsg()
  }

  return (
    <Button onClick={() => addItem()} variant="powder">
      <FaShoppingCart /> Add to Cart
    </Button>
  )
}

export default AddToCartButton
